import { useAtomValue, useSetAtom } from 'jotai/react';

import type { IProvider, ProviderId } from '@/providers';
import { providerAtom, providerIdAtom } from '@/store/provider-atoms';

export const useProvider = (): [IProvider, (id: ProviderId) => void] => {
  const setProviderId = useSetAtom(providerIdAtom);
  const provider = useAtomValue(providerAtom);
  return [provider, setProviderId];
};
